<template>
	<div v-if="breakdown.length" class="breakdown">
		<slide-up-down :active="showingBreakdown" class="no-auto-hide" use-hidden="false">
			<div class="breakdown__content active">
				<div v-for="(bd, idx) in breakdown" v-bind:key="bd.id" class="breakdown__item">
					<div class="label" :class="{ 'big': idx === 0 }">{{ bd.title }}</div>
					<p v-for="val in bd.value" :key="val.id" v-html="val"></p>
				</div>
			</div>
		</slide-up-down>

		<transition name="fade" mode="in-out">
			<a href="#" @click.prevent="showBreakdown" @keydown.enter.prevent="showBreakdown" class="breakdown__toggle view_breakdown" v-if="!showingBreakdown">{{ this.$store.state.language.view_more }}</a>
			<a href="#" @click.prevent="hideBreakdown" @keydown.enter.prevent="hideBreakdown" class="breakdown__toggle close_breakdown" v-if="showingBreakdown">{{ this.$store.state.language.close }}</a>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'Breakdown',
	props: {
		breakdownVisible: {
			type: Boolean,
			required: true
		}
	},
	data: function(){
		return {
			showingBreakdown: this.breakdownVisible
		}
	},
	computed: {
		breakdown() {
			return this.$store.state.breakdown
		}
	},
	methods: {
		showBreakdown(){
			this.showingBreakdown = true
		},
		hideBreakdown(){
			this.showingBreakdown = false
		}
	},
	watch: {
		breakdownVisible() {
			this.showingBreakdown = this.breakdownVisible
		}
	}
}
</script>

<style scoped>

</style>